export const GET_CANBUS_TROUBLESHOOTS_TUTORIAL_REQUEST =
  'GET_CANBUS_TROUBLESHOOTS_TUTORIAL_REQUEST';
export const GET_CANBUS_TROUBLESHOOTS_TUTORIAL_SUCCESS =
  'GET_CANBUS_TROUBLESHOOTS_TUTORIAL_SUCCESS';
export const GET_CANBUS_TROUBLESHOOTS_TUTORIAL_ERROR =
  'GET_CANBUS_TROUBLESHOOTS_TUTORIAL_ERROR';
